import { useMutation } from "@apollo/client";
import { evictFields } from "../../../helpers/cache";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

import { UPDATE_CONTACT } from "../contact.queries";
import { parseParams } from "../../../helpers/clean-object";

import { UpdateContactInput } from "../../../__generated__/globalTypes";
import {
  UpdateContactMutation,
  UpdateContactMutationVariables,
} from "../../../__generated__/UpdateContactMutation";

interface IProps {
  id: number;
  onCompleted: () => any;
}

export const useUpdateContact = ({ id, onCompleted }: IProps) => {
  const form = useForm<UpdateContactInput>({
    mode: "all",
  });
  const [mutate, { loading }] = useMutation<
    UpdateContactMutation,
    UpdateContactMutationVariables
  >(UPDATE_CONTACT, {
    refetchQueries: ["ContactsQuery", "ContactQuery"],
    update(cache) {
      evictFields(cache, ["contact", "contacts"]);
    },
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updateContact?.ok) {
        onCompleted();
      } else {
        throw Error(data?.updateContact?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
